module.exports = __webpack_public_path__ + "img/slow_loader.552cc4da.svg";